import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import toast from 'react-hot-toast';
import SelfieForm from "../../../../components/SingleIMGDropZone";
import { setInputFile, toBase64 } from "pages/registers/helpers/files-helper";

//Form Selfie
function Index(props) {
    useEffect(async () => {
        //Reloading user picture
        const picture = localStorage.getItem('picture')
        const dropzone = document.querySelector('.dropzone')
        const input = dropzone.querySelector('input[type="file"]')
        if (picture) {
            dropzone.style.backgroundImage = `url(${picture})`
            handleFileImgDrop({
                file_image: await setInputFile(picture, input, 'picture.png'),
                image: picture
            })
        } else {
            dropzone.style.backgroundImage = `url('https://cdn.sigmobi.com/avatar_empty.png')`  
        }
    }, [])

    const handleFileImgDrop = async (picture) => {
        const toastOpts = {
            position: 'bottom-center',
            reverseOrder: true
        }
        if (picture?.file_image?.size <= 0) {
            return toast.error('Arquivo selfie é obrigatório.', toastOpts)
        }
        if (!picture?.file_image?.type?.includes('image/')) {
            return toast.error('Somente arquivo de imagem dos tipos jpg,png e jpeg são permitidos.', toastOpts)
        }
        if (picture?.image) {
            localStorage.setItem('picture', await toBase64(picture.file_image))
        }
        props.handleFileImgDrop(picture)
    }

    return (
        <Form onSubmit={handleFileImgDrop} className="col-12" id="selfie">
            <Form.Group className="mb-5 mt-5">
                {/* <Form.Label>
                      Tirar Selfie 
                    </Form.Label> */}
                <SelfieForm
                    is_avatar={true}
                    handleFileImgDrop={handleFileImgDrop} // Função para lidar com o upload de uma nova selfie
                    img={props.existingSelfie} // URL da selfie existente para edição, ou null se for nova
                    url_img={props.existingSelfie} // URL da imagem a ser exibida inicialmente
                    name_product="picture" // Nome associado à imagem (Selfie)
                    entity_id={props.entityId} // ID do usuário ou entidade
                    before_file={null} // Dados adicionais, se necessário
                    file_dir_name="selfies" // Diretório onde as selfies serão salvas
                />
            </Form.Group>
        </Form>
    )
}

const mapStateToProps = (state) => {
    return {}
};

export default withTranslation()(withRouter(connect(mapStateToProps, {})(Index)));